export const hasPermission = (requiredPermission: string, userPermissions?: string[]) =>
  userPermissions?.includes(requiredPermission);

export const hasRole = (requiredRoleList: string[], userRoles?: string[]) =>
  requiredRoleList.some((role) => userRoles?.includes(role));
